import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export type ActionPopupAction = {
  label: string;
  onClick: VoidFunction;
  variant?: 'text' | 'outlined' | 'contained';
};

type ActionPopupProps = {
  open: boolean;
  title: string;
  description?: string;
  actions: ActionPopupAction[];
  onClose: VoidFunction;
};

const ActionPopup = ({
  open,
  title,
  description,
  actions,
  onClose,
}: ActionPopupProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '16px',
          padding: '16px',
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      {description && (
        <DialogContent>
          <DialogContentText>{description}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        {actions.map((action) => (
          <Button
            key={action.label}
            variant={action.variant ?? 'outlined'}
            onClick={action.onClick}
            sx={{ textTransform: 'capitalize' }}
          >
            {action.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

export default ActionPopup;